import { Skill } from '@/mocks/skillsData';

export const cryptoskillMcpServersBData: Skill[] = [
  // ── Hedera Explorer MCP ──
  {
    id: 'hedera-explorer-mcp',
    name: 'hedera-explorer-mcp',
    author: 'Hedera',
    authorHandle: '@hedera',
    tag: 'Skill',
    category: 'analytics',
    description: 'Hedera Explorer MCP server. Hedera Hashgraph blockchain explorer access via Model Context Protocol — transaction lookup, token queries, and account analytics.',
    downloads: 27800,
    stars: 790,
    version: '1.1.0',
    installCommand: '> install the hedera-explorer-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hedera-explorer-mcp',
    usageExample: '> query Hedera transactions\n> look up token info\n> analyze account activity',
    detailedDescription: 'Hedera Explorer MCP server for Hedera Hashgraph blockchain data. Query transaction records, look up HTS token details, analyze account activity, and access Hedera network statistics via standardized MCP interfaces.',
  },
  // ── Hedera MCP Explorer ──
  {
    id: 'hedera-mcp-explorer',
    name: 'hedera-mcp-explorer',
    author: 'Hedera Community',
    authorHandle: '@hedera_community',
    tag: 'Skill',
    category: 'analytics',
    description: 'Hedera MCP explorer. Enhanced Hedera Hashgraph analytics via Model Context Protocol — DeFi protocol metrics, NFT collections, and consensus service data.',
    downloads: 21400,
    stars: 610,
    version: '1.0.2',
    installCommand: '> install the hedera-mcp-explorer skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hedera-mcp-explorer',
    usageExample: '> explore Hedera DeFi\n> query NFT collections\n> access HCS data',
    detailedDescription: 'Enhanced Hedera MCP explorer with DeFi-focused analytics. Query SaucerSwap and other Hedera DeFi protocols, explore NFT collections, access Hedera Consensus Service (HCS) message streams, and monitor HBAR staking.',
  },
  // ── Hedera MCP Server ──
  {
    id: 'hedera-mcp-server',
    name: 'hedera-mcp-server',
    author: 'Hedera',
    authorHandle: '@hedera',
    tag: 'Skill',
    category: 'defi',
    description: 'Hedera official MCP server. Full Hedera Hashgraph access via Model Context Protocol — HBAR transfers, HTS tokens, smart contracts, and consensus service.',
    downloads: 34600,
    stars: 990,
    version: '1.4.0',
    installCommand: '> install the hedera-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hedera-mcp-server',
    usageExample: '> transfer HBAR\n> create HTS token\n> deploy Hedera contract',
    detailedDescription: 'Official Hedera MCP server providing comprehensive Hashgraph access. Transfer HBAR, create and manage HTS tokens, deploy Hedera smart contracts (EVM-compatible), and interact with the Hedera Consensus Service.',
    featured: true,
  },
  // ── Hedera MCP ──
  {
    id: 'hedera-mcp',
    name: 'hedera-mcp',
    author: 'Hedera Community',
    authorHandle: '@hedera_community',
    tag: 'Skill',
    category: 'defi',
    description: 'Hedera MCP core. Lightweight Hedera Hashgraph operations via Model Context Protocol — basic HBAR transfers, HTS queries, and account management.',
    downloads: 28100,
    stars: 800,
    version: '1.2.0',
    installCommand: '> install the hedera-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hedera-mcp',
    usageExample: '> send HBAR\n> query HTS balance\n> manage account',
    detailedDescription: 'Hedera MCP core library for lightweight Hashgraph operations. Execute HBAR transfers, query HTS token balances, manage account information, and interact with basic Hedera network services via MCP.',
  },
  // ── Hedera Network Explorer MCP ──
  {
    id: 'hedera-network-explorer-mcp',
    name: 'hedera-network-explorer-mcp',
    author: 'Hedera Labs',
    authorHandle: '@hederalabs',
    tag: 'Skill',
    category: 'analytics',
    description: 'Hedera Network Explorer MCP. Comprehensive Hedera network analytics via Model Context Protocol — node health, network performance, and validator data.',
    downloads: 18700,
    stars: 530,
    version: '1.0.1',
    installCommand: '> install the hedera-network-explorer-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hedera-network-explorer-mcp',
    usageExample: '> check Hedera node health\n> monitor network TPS\n> query validator info',
    detailedDescription: 'Hedera Network Explorer MCP for infrastructure analytics. Monitor node health across the Hedera council network, track transaction throughput and finality times, analyze stake distribution, and access network performance metrics.',
  },
  // ── HederaOracle ──
  {
    id: 'hederaoracle',
    name: 'hederaoracle',
    author: 'HederaOracle',
    authorHandle: '@hederaoracle',
    tag: 'Skill',
    category: 'analytics',
    description: 'HederaOracle price oracle. Decentralized price feeds on Hedera Hashgraph aggregating DEX and off-chain data for DeFi protocols.',
    downloads: 16300,
    stars: 460,
    version: '1.0.0',
    installCommand: '> install the hederaoracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hederaoracle',
    usageExample: '> get Hedera token price\n> query oracle feeds\n> access price aggregation',
    detailedDescription: 'HederaOracle decentralized price feed for the Hedera Hashgraph ecosystem. Aggregates HBAR and HTS token prices from SaucerSwap and other Hedera DEXes with confidence scores and TWAP calculations.',
  },
  // ── Helius MCP ──
  {
    id: 'helius-mcp',
    name: 'helius-mcp',
    author: 'Helius',
    authorHandle: '@heliuslabs',
    tag: 'Skill',
    category: 'analytics',
    description: 'Helius MCP server. Official Helius Solana RPC and data API via Model Context Protocol — enhanced transactions, NFT APIs, webhooks, and DAS standard.',
    downloads: 58400,
    stars: 1670,
    version: '2.0.0',
    installCommand: '> install the helius-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/helius-mcp',
    usageExample: '> query Solana via Helius\n> get NFT metadata\n> set webhook',
    detailedDescription: 'Official Helius MCP server for Solana data. Access enhanced transaction parsing, query NFT metadata via the Digital Asset Standard (DAS), set up webhooks for on-chain events, and use Helius\'s premium RPC endpoints.',
    featured: true,
    trending: true,
  },
  // ── Hive Crypto MCP ──
  {
    id: 'hive-crypto-mcp',
    name: 'hive-crypto-mcp',
    author: 'Hive Blockchain',
    authorHandle: '@hiveblog',
    tag: 'Skill',
    category: 'defi',
    description: 'Hive blockchain MCP server. Hive social blockchain access via Model Context Protocol — HIVE/HBD transfers, content publishing, and DHF governance.',
    downloads: 19200,
    stars: 550,
    version: '1.0.3',
    installCommand: '> install the hive-crypto-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hive-crypto-mcp',
    usageExample: '> transfer HIVE tokens\n> publish content on-chain\n> vote on DHF proposals',
    detailedDescription: 'Hive blockchain MCP server for social blockchain operations. Transfer HIVE and HBD, publish and interact with content on the decentralized social layer, participate in DHF (Decentralized Hive Fund) governance, and power up/down HIVE.',
  },
  // ── Hyperlane MCP ──
  {
    id: 'hyperlane-mcp',
    name: 'hyperlane-mcp',
    author: 'Hyperlane',
    authorHandle: '@Hyperlane_',
    tag: 'Skill',
    category: 'defi',
    description: 'Hyperlane MCP server. Permissionless interoperability protocol via Model Context Protocol — deploy mailboxes, send cross-chain messages, and configure security modules.',
    downloads: 36800,
    stars: 1050,
    version: '1.3.0',
    installCommand: '> install the hyperlane-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/hyperlane-mcp',
    usageExample: '> send cross-chain message\n> deploy Hyperlane mailbox\n> configure ISM security',
    detailedDescription: 'Hyperlane permissionless interoperability MCP server. Deploy Hyperlane mailboxes on any chain, send cross-chain messages, configure Interchain Security Modules (ISMs), and build chain-agnostic applications.',
    trending: true,
  },
  // ── Injective MCP Server ──
  {
    id: 'injective-mcp-server',
    name: 'injective-mcp-server',
    author: 'Injective Community',
    authorHandle: '@injective',
    tag: 'Skill',
    category: 'trading',
    description: 'Injective MCP server. Cosmos-based derivatives DEX access via Model Context Protocol — perp trading, spot markets, and INJ staking.',
    downloads: 31700,
    stars: 900,
    version: '1.2.0',
    installCommand: '> install the injective-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/injective-mcp-server',
    usageExample: '> trade perps on Injective\n> access spot markets\n> stake INJ',
    detailedDescription: 'Injective MCP server for Cosmos-based derivatives trading. Execute perpetual and spot trades on Injective\'s on-chain order book, manage INJ staking, access synthetic asset markets, and query market maker data.',
  },
  // ── Injective Official MCP Server ──
  {
    id: 'injective-official-mcp-server',
    name: 'injective-official-mcp-server',
    author: 'Injective Labs',
    authorHandle: '@InjectiveLabs',
    tag: 'Skill',
    category: 'trading',
    description: 'Injective official MCP server. Full Injective Protocol access via Model Context Protocol — order book DEX, derivatives, prediction markets, and governance.',
    downloads: 38200,
    stars: 1090,
    version: '1.5.0',
    installCommand: '> install the injective-official-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/injective-official-mcp-server',
    usageExample: '> trade on Injective DEX\n> access derivatives markets\n> participate in governance',
    detailedDescription: 'Official Injective Labs MCP server with full protocol access. Trade on the Injective order book DEX, access derivatives and binary options markets, participate in governance, and interact with the Injective cross-chain bridge.',
    featured: true,
  },
  // ── Jupiter MCP ──
  {
    id: 'jupiter-mcp',
    name: 'jupiter-mcp',
    author: 'Jupiter Exchange',
    authorHandle: '@JupiterExchange',
    tag: 'Skill',
    category: 'defi',
    description: 'Jupiter MCP server. Solana\'s leading DEX aggregator via Model Context Protocol — best swap routes, limit orders, DCA strategies, and perp trading.',
    downloads: 86400,
    stars: 2470,
    version: '2.0.0',
    installCommand: '> install the jupiter-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/jupiter-mcp',
    usageExample: '> swap via Jupiter\n> set limit order\n> start DCA strategy',
    detailedDescription: 'Official Jupiter Exchange MCP server for Solana\'s leading DEX aggregator. Find optimal swap routes across 20+ Solana DEXes, execute limit orders, set up Dollar Cost Averaging strategies, and trade perpetuals on Jupiter Perps.',
    featured: true,
    trending: true,
  },
  // ── Kraken CLI MCP ──
  {
    id: 'kraken-cli-mcp',
    name: 'kraken-cli-mcp',
    author: 'Kraken Community',
    authorHandle: '@krakenfx',
    tag: 'Skill',
    category: 'trading',
    description: 'Kraken CLI MCP server. Command-line Kraken exchange access via Model Context Protocol — scriptable trading, account management, and market data retrieval.',
    downloads: 27300,
    stars: 780,
    version: '1.1.0',
    installCommand: '> install the kraken-cli-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/kraken-cli-mcp',
    usageExample: '> trade via Kraken CLI\n> manage account via MCP\n> fetch market data',
    detailedDescription: 'Kraken CLI MCP server providing scriptable exchange access. Execute trades, manage account positions, retrieve market data, and automate trading workflows through a command-line-style Model Context Protocol interface.',
  },
  // ── Kukapay Crypto Fear/Greed MCP ──
  {
    id: 'kukapay-crypto-feargreed-mcp',
    name: 'kukapay-crypto-feargreed-mcp',
    author: 'Kukapay',
    authorHandle: '@kukapay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Kukapay Crypto Fear & Greed MCP. Daily and real-time market sentiment index via Model Context Protocol with historical tracking and automated signal generation.',
    downloads: 31800,
    stars: 910,
    version: '1.1.0',
    installCommand: '> install the kukapay-crypto-feargreed-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/kukapay-crypto-feargreed-mcp',
    usageExample: '> get F&G index\n> track historical sentiment\n> generate signal',
    detailedDescription: 'Kukapay Crypto Fear & Greed MCP server providing sentiment analytics. Access real-time and daily F&G index values, analyze historical sentiment patterns, generate automated buy/sell signals at extreme readings.',
  },
  // ── Kukapay Crypto Indicators MCP ──
  {
    id: 'kukapay-crypto-indicators-mcp',
    name: 'kukapay-crypto-indicators-mcp',
    author: 'Kukapay',
    authorHandle: '@kukapay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Kukapay Crypto Indicators MCP. On-chain and market technical indicators via Model Context Protocol — MVRV, NVT, SOPR, RSI, and MACD for any asset.',
    downloads: 28400,
    stars: 810,
    version: '1.2.0',
    installCommand: '> install the kukapay-crypto-indicators-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/kukapay-crypto-indicators-mcp',
    usageExample: '> get MVRV ratio\n> calculate RSI\n> query on-chain indicators',
    detailedDescription: 'Kukapay Crypto Indicators MCP server providing on-chain and technical analysis indicators. Access MVRV, NVT, SOPR, NUPL and other on-chain metrics alongside traditional TA indicators like RSI, MACD, and Bollinger Bands.',
  },
  // ── Kukapay CryptoPanic MCP ──
  {
    id: 'kukapay-cryptopanic-mcp',
    name: 'kukapay-cryptopanic-mcp',
    author: 'Kukapay',
    authorHandle: '@kukapay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Kukapay CryptoPanic MCP. Crypto news sentiment aggregator via Model Context Protocol — news scoring, panic/fomo detection, and market-moving event alerts.',
    downloads: 24700,
    stars: 700,
    version: '1.0.3',
    installCommand: '> install the kukapay-cryptopanic-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/kukapay-cryptopanic-mcp',
    usageExample: '> get panic news score\n> detect FOMO signals\n> set market-moving alert',
    detailedDescription: 'Kukapay CryptoPanic MCP server for news sentiment analysis. Aggregate and score news articles by panic/fomo intensity, detect early market-moving events, and track community reaction to news across social platforms.',
  },
  // ── Kukapay Hyperliquid Info MCP ──
  {
    id: 'kukapay-hyperliquid-info-mcp',
    name: 'kukapay-hyperliquid-info-mcp',
    author: 'Kukapay',
    authorHandle: '@kukapay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Kukapay Hyperliquid Info MCP. Hyperliquid DEX analytics via Model Context Protocol — open interest, funding rates, liquidations, and leaderboard data.',
    downloads: 29300,
    stars: 840,
    version: '1.1.0',
    installCommand: '> install the kukapay-hyperliquid-info-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/kukapay-hyperliquid-info-mcp',
    usageExample: '> get HL open interest\n> query funding rates\n> check leaderboard',
    detailedDescription: 'Kukapay Hyperliquid analytics MCP server. Monitor open interest across Hyperliquid markets, track funding rate changes, analyze liquidation clusters, and access leaderboard performance data via standardized MCP interfaces.',
  },
  // ── Kukapay Uniswap Trader MCP ──
  {
    id: 'kukapay-uniswap-trader-mcp',
    name: 'kukapay-uniswap-trader-mcp',
    author: 'Kukapay',
    authorHandle: '@kukapay',
    tag: 'Skill',
    category: 'defi',
    description: 'Kukapay Uniswap Trader MCP. Advanced Uniswap v3/v4 trading via Model Context Protocol — concentrated liquidity positions, range orders, and fee tier optimization.',
    downloads: 36400,
    stars: 1040,
    version: '1.2.0',
    installCommand: '> install the kukapay-uniswap-trader-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/kukapay-uniswap-trader-mcp',
    usageExample: '> add Uniswap v3 liquidity\n> set range order\n> optimize fee tier',
    detailedDescription: 'Kukapay Uniswap Trader MCP for advanced liquidity management. Add and manage concentrated liquidity positions on Uniswap v3/v4, set range orders, optimize fee tier selection, and monitor LP position performance.',
    trending: true,
  },
  // ── Lido MCP Agent ──
  {
    id: 'lido-mcp-agent',
    name: 'lido-mcp-agent',
    author: 'Lido Community',
    authorHandle: '@LidoFinance',
    tag: 'Skill',
    category: 'defi',
    description: 'Lido MCP agent. Autonomous Lido staking operations via Model Context Protocol — stETH minting, rewards compounding, and governance participation.',
    downloads: 43700,
    stars: 1250,
    version: '1.3.0',
    installCommand: '> install the lido-mcp-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/lido-mcp-agent',
    usageExample: '> stake ETH on Lido\n> compound stETH rewards\n> vote on governance',
    detailedDescription: 'Lido staking MCP agent for autonomous operations. Stake ETH to receive stETH, automate reward compounding, participate in Lido DAO governance votes, manage wstETH wrapping, and monitor validator performance.',
    featured: true,
  },
  // ── Lido MCP Server ──
  {
    id: 'lido-mcp-server',
    name: 'lido-mcp-server',
    author: 'Lido Finance',
    authorHandle: '@LidoFinance',
    tag: 'Skill',
    category: 'defi',
    description: 'Lido official MCP server. Full Lido liquid staking protocol access via Model Context Protocol — stETH, wstETH, Lido on Solana, and Polygon staking.',
    downloads: 51400,
    stars: 1470,
    version: '2.0.0',
    installCommand: '> install the lido-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/lido-mcp-server',
    usageExample: '> stake via Lido MCP\n> wrap stETH to wstETH\n> stake on Solana via Lido',
    detailedDescription: 'Official Lido Finance MCP server for liquid staking. Access Ethereum stETH/wstETH staking, Lido on Solana for stSOL, and Polygon staking through standardized MCP interfaces with full protocol data access.',
    featured: true,
    trending: true,
  },
  // ── LiFi MCP ──
  {
    id: 'lifi-mcp',
    name: 'lifi-mcp',
    author: 'LI.FI',
    authorHandle: '@lifiprotocol',
    tag: 'Skill',
    category: 'defi',
    description: 'LI.FI MCP server. Cross-chain bridging and DEX aggregation via Model Context Protocol — find optimal routes across 40+ bridges and 20+ DEXes.',
    downloads: 47600,
    stars: 1360,
    version: '1.4.0',
    installCommand: '> install the lifi-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/lifi-mcp',
    usageExample: '> find best bridge route\n> cross-chain swap\n> compare bridge fees',
    detailedDescription: 'LI.FI MCP server for multi-chain asset routing. Find optimal cross-chain routes across 40+ bridge providers and 20+ DEX aggregators, execute single-step cross-chain swaps, and compare fees and settlement times.',
    trending: true,
  },
  // ── Lightning MCP (mcp-servers variant) ──
  {
    id: 'lightning-mcp-server',
    name: 'lightning-mcp',
    author: 'Lightning Network',
    authorHandle: '@lightning',
    tag: 'Skill',
    category: 'defi',
    description: 'Lightning Network MCP server variant. Enhanced Bitcoin Lightning access via Model Context Protocol — channel management, payment routing, and LNURL support.',
    downloads: 38400,
    stars: 1090,
    version: '2.0.0',
    installCommand: '> install the lightning-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/lightning-mcp',
    usageExample: '> open Lightning channel\n> route payment\n> use LNURL link',
    detailedDescription: 'Lightning Network MCP server for enhanced payment operations. Manage channels, route payments through the Lightning network, support LNURL and LND/CLN backends, and access real-time network graph data.',
  },
  // ── Maiat MCP ──
  {
    id: 'maiat-mcp',
    name: 'maiat-mcp',
    author: 'Maiat',
    authorHandle: '@maiat_ai',
    tag: 'Skill',
    category: 'tools',
    description: 'Maiat MCP server. AI trust and safety layer via Model Context Protocol — intent verification, transaction simulation, and fraud prevention for AI agents.',
    downloads: 26800,
    stars: 760,
    version: '1.1.0',
    installCommand: '> install the maiat-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/maiat-mcp',
    usageExample: '> verify agent intent\n> simulate transaction\n> check fraud risk',
    detailedDescription: 'Maiat AI safety MCP server providing trust and fraud prevention for autonomous agents. Verify transaction intent against stated goals, simulate transactions before execution, and score fraud risk to prevent malicious operations.',
  },
  // ── MCP Bundle Agent ──
  {
    id: 'mcp-bundle-agent',
    name: 'mcp-bundle-agent',
    author: 'MCP Community',
    authorHandle: '@mcp_community',
    tag: 'Skill',
    category: 'tools',
    description: 'MCP Bundle Agent. Bundle multiple MCP server capabilities into a single agent endpoint — compose skills, manage context, and orchestrate multi-server workflows.',
    downloads: 32100,
    stars: 920,
    version: '1.2.0',
    installCommand: '> install the mcp-bundle-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/mcp-bundle-agent',
    usageExample: '> bundle MCP skills\n> compose multi-server workflow\n> manage agent context',
    detailedDescription: 'MCP Bundle Agent for orchestrating multiple MCP servers through a single endpoint. Compose skills from different MCP providers, manage shared context across tool calls, and build complex multi-step agent workflows.',
    trending: true,
  },
  // ── MCP Crypto Server ──
  {
    id: 'mcp-crypto-server-generic',
    name: 'mcp-crypto-server',
    author: 'MCP Community',
    authorHandle: '@mcp_community',
    tag: 'Skill',
    category: 'tools',
    description: 'MCP Crypto Server generic implementation. Reference MCP server for crypto operations — standard tool definitions, authentication patterns, and data schemas.',
    downloads: 19400,
    stars: 550,
    version: '1.0.0',
    installCommand: '> install the mcp-crypto-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/mcp-crypto-server',
    usageExample: '> explore MCP crypto tools\n> reference implementation\n> build custom server',
    detailedDescription: 'MCP Crypto Server generic reference implementation. Demonstrates standard tool definitions, authentication patterns, error handling, and data schemas for building custom crypto MCP servers.',
  },
  // ── MCP Protocol Gateway ──
  {
    id: 'mcp-protocol-gateway',
    name: 'mcp-protocol-gateway',
    author: 'MCP Labs',
    authorHandle: '@mcp_labs',
    tag: 'Skill',
    category: 'tools',
    description: 'MCP Protocol Gateway. Universal gateway for connecting AI agents to crypto APIs via Model Context Protocol — OAuth handling, rate limiting, and protocol translation.',
    downloads: 37800,
    stars: 1080,
    version: '1.3.0',
    installCommand: '> install the mcp-protocol-gateway skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/mcp-protocol-gateway',
    usageExample: '> setup MCP gateway\n> handle API OAuth\n> manage rate limits',
    detailedDescription: 'MCP Protocol Gateway providing universal API connectivity for AI agents. Handle OAuth authentication flows, manage API rate limiting, translate between REST/GraphQL and MCP protocol formats, and route requests across multiple crypto services.',
  },
  // ── MCP Server (generic) ──
  {
    id: 'mcp-server-generic',
    name: 'mcp-server',
    author: 'MCP Community',
    authorHandle: '@mcp_community',
    tag: 'Skill',
    category: 'tools',
    description: 'MCP Server template. Minimal crypto MCP server template — standard tool schemas, streaming support, and session management for custom server development.',
    downloads: 24300,
    stars: 690,
    version: '1.0.2',
    installCommand: '> install the mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/mcp-server',
    usageExample: '> use MCP template\n> add custom tools\n> test server locally',
    detailedDescription: 'Minimal MCP server template for custom crypto server development. Includes standard tool schemas, streaming response support, session management, and testing utilities to accelerate MCP server development.',
  },
  // ── MCP Tester ──
  {
    id: 'mcp-tester',
    name: 'mcp-tester',
    author: 'MCP Labs',
    authorHandle: '@mcp_labs',
    tag: 'Skill',
    category: 'tools',
    description: 'MCP Tester. Test harness for MCP server validation — automated tool testing, response schema validation, and performance benchmarking.',
    downloads: 18700,
    stars: 530,
    version: '1.1.0',
    installCommand: '> install the mcp-tester skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/mcp-tester',
    usageExample: '> test MCP server\n> validate tool responses\n> benchmark performance',
    detailedDescription: 'MCP Tester automated test harness for validating MCP server implementations. Run tool invocation tests, validate response schemas against specifications, benchmark throughput and latency, and generate compliance reports.',
  },
  // ── MeowBlock MCP ──
  {
    id: 'meowblock-mcp',
    name: 'meowblock-mcp',
    author: 'MeowBlock',
    authorHandle: '@meowblock',
    tag: 'Skill',
    category: 'analytics',
    description: 'MeowBlock MCP server. Meme coin analytics and tracking via Model Context Protocol — launch detection, social metrics, liquidity monitoring, and sniper activity.',
    downloads: 41800,
    stars: 1190,
    version: '1.0.3',
    installCommand: '> install the meowblock-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/meowblock-mcp',
    usageExample: '> detect meme launches\n> track social metrics\n> monitor liquidity',
    detailedDescription: 'MeowBlock MCP server for meme coin analytics. Detect new meme coin launches in real time, track social media momentum and community growth, monitor liquidity pool health, and identify sniper bot activity.',
    trending: true,
  },
  // ── Meson MCP ──
  {
    id: 'meson-mcp',
    name: 'meson-mcp',
    author: 'Meson Protocol',
    authorHandle: '@meson_fi',
    tag: 'Skill',
    category: 'defi',
    description: 'Meson MCP server. Fast stablecoin cross-chain swaps via Model Context Protocol — instant USDC/USDT transfers across 30+ networks with minimal fees.',
    downloads: 33600,
    stars: 960,
    version: '1.2.0',
    installCommand: '> install the meson-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/meson-mcp',
    usageExample: '> swap USDC cross-chain\n> fast stablecoin bridge\n> check bridge fees',
    detailedDescription: 'Meson Protocol MCP server for instant stablecoin cross-chain swaps. Transfer USDC and USDT across 30+ networks in seconds with minimal fees, leveraging Meson\'s liquidity network and atomic swap architecture.',
  },
  // ── Monad MCP ──
  {
    id: 'monad-mcp',
    name: 'monad-mcp',
    author: 'Monad',
    authorHandle: '@monad_xyz',
    tag: 'Skill',
    category: 'defi',
    description: 'Monad MCP server. High-performance EVM-compatible L1 access via Model Context Protocol — 10,000 TPS blockchain interactions, smart contracts, and DeFi.',
    downloads: 48200,
    stars: 1380,
    version: '1.0.0',
    installCommand: '> install the monad-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/monad-mcp',
    usageExample: '> deploy on Monad\n> interact with Monad DeFi\n> test high TPS operations',
    detailedDescription: 'Monad MCP server for the high-performance EVM-compatible L1 blockchain. Deploy and interact with Solidity smart contracts, access Monad DeFi protocols, and test applications leveraging Monad\'s 10,000 TPS throughput.',
    featured: true,
    trending: true,
  },
  // ── Nate The Grait ──
  {
    id: 'nate-the-grait',
    name: 'nate-the-grait',
    author: 'Nate Community',
    authorHandle: '@nate_grait',
    tag: 'Skill',
    category: 'tools',
    description: 'Nate The Grait MCP. Community-built AI trading agent toolkit via Model Context Protocol — signal generation, portfolio analytics, and trade automation.',
    downloads: 16800,
    stars: 480,
    version: '1.0.1',
    installCommand: '> install the nate-the-grait skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/nate-the-grait',
    usageExample: '> get trade signals\n> analyze portfolio\n> automate trades',
    detailedDescription: 'Nate The Grait community AI trading MCP toolkit. Generate trade signals from technical and on-chain analysis, analyze portfolio performance, and automate trading strategies through standardized MCP interfaces.',
  },
  // ── NEAR MCP ──
  {
    id: 'near-mcp',
    name: 'near-mcp',
    author: 'NEAR Protocol',
    authorHandle: '@NEARProtocol',
    tag: 'Skill',
    category: 'defi',
    description: 'NEAR Protocol MCP server. Official NEAR blockchain access via Model Context Protocol — NEAR/FT transfers, smart contracts, Aurora EVM, and DeFi protocols.',
    downloads: 42400,
    stars: 1210,
    version: '1.4.0',
    installCommand: '> install the near-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/near-mcp',
    usageExample: '> transfer NEAR tokens\n> call smart contract\n> access Aurora EVM',
    detailedDescription: 'Official NEAR Protocol MCP server. Transfer NEAR and fungible tokens, call smart contracts, interact with Aurora EVM-compatible sidechain, access Ref Finance and other NEAR DeFi protocols, and participate in governance.',
    featured: true,
  },
  // ── Nodit MCP ──
  {
    id: 'nodit-mcp',
    name: 'nodit-mcp',
    author: 'Nodit',
    authorHandle: '@nodit_io',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nodit MCP server. Multi-chain blockchain data indexer via Model Context Protocol — NFT metadata, token balances, transaction history, and DeFi analytics.',
    downloads: 31700,
    stars: 900,
    version: '1.2.0',
    installCommand: '> install the nodit-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/nodit-mcp',
    usageExample: '> query NFT metadata\n> get token balances\n> fetch DeFi analytics',
    detailedDescription: 'Nodit MCP multi-chain blockchain data indexer. Access normalized NFT metadata, cross-chain token balances, complete transaction history, and DeFi protocol analytics via standardized MCP interfaces across 10+ networks.',
  },
  // ── Nookplot MCP Agent ──
  {
    id: 'nookplot-mcp-agent',
    name: 'nookplot-mcp-agent',
    author: 'Nookplot',
    authorHandle: '@nookplot',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nookplot MCP agent. On-chain narrative and trend analysis via Model Context Protocol — whale movement stories, protocol adoption curves, and ecosystem growth tracking.',
    downloads: 22600,
    stars: 640,
    version: '1.0.2',
    installCommand: '> install the nookplot-mcp-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/nookplot-mcp-agent',
    usageExample: '> track whale narratives\n> analyze adoption curves\n> monitor ecosystem growth',
    detailedDescription: 'Nookplot MCP agent for on-chain narrative analysis. Track whale wallet movement stories, analyze protocol adoption curves, monitor ecosystem growth metrics, and surface emerging narratives from on-chain data patterns.',
  },
  // ── Nookplot MCP ──
  {
    id: 'nookplot-mcp',
    name: 'nookplot-mcp',
    author: 'Nookplot',
    authorHandle: '@nookplot',
    tag: 'Skill',
    category: 'analytics',
    description: 'Nookplot MCP core. Blockchain chart and visualization data via Model Context Protocol — candlestick data, volume profiles, and custom indicator computation.',
    downloads: 27400,
    stars: 780,
    version: '1.1.0',
    installCommand: '> install the nookplot-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/nookplot-mcp',
    usageExample: '> get candlestick data\n> compute volume profile\n> calculate custom indicators',
    detailedDescription: 'Nookplot MCP core for charting and technical analysis data. Fetch OHLCV candlestick data, compute volume profiles, calculate custom technical indicators, and export formatted chart data for visualization.',
  },
  // ── OpenZeppelin MCP ──
  {
    id: 'openzeppelin-mcp',
    name: 'openzeppelin-mcp',
    author: 'OpenZeppelin',
    authorHandle: '@OpenZeppelin',
    tag: 'Skill',
    category: 'tools',
    description: 'OpenZeppelin MCP server. Smart contract security library and auditing via Model Context Protocol — security checks, contract wizard, and upgrade management.',
    downloads: 56800,
    stars: 1620,
    version: '2.0.0',
    installCommand: '> install the openzeppelin-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/openzeppelin-mcp',
    usageExample: '> check contract security\n> generate OZ contract\n> manage upgrades',
    detailedDescription: 'OpenZeppelin MCP server providing enterprise-grade smart contract security. Run security checks against OpenZeppelin standards, generate contracts using the Contract Wizard, manage proxy upgrades, and access the Defender platform.',
    featured: true,
    trending: true,
  },
  // ── ProFunding MCP ──
  {
    id: 'profunding-mcp',
    name: 'profunding-mcp',
    author: 'ProFunding',
    authorHandle: '@profunding_io',
    tag: 'Skill',
    category: 'trading',
    description: 'ProFunding MCP server. Professional perpetual funding rate analytics via Model Context Protocol — multi-exchange funding arbitrage, carry trade signals, and rate forecasting.',
    downloads: 29800,
    stars: 850,
    version: '1.1.0',
    installCommand: '> install the profunding-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/profunding-mcp',
    usageExample: '> analyze funding arb\n> get carry trade signals\n> forecast funding rates',
    detailedDescription: 'ProFunding professional MCP server for funding rate strategy. Identify cross-exchange funding arbitrage opportunities, generate carry trade signals, forecast future funding rates, and monitor position costs across perpetual platforms.',
  },
  // ── Pythia Oracle MCP ──
  {
    id: 'pythia-oracle-mcp',
    name: 'pythia-oracle-mcp',
    author: 'Pythia',
    authorHandle: '@pythia_oracle',
    tag: 'Skill',
    category: 'analytics',
    description: 'Pythia Oracle MCP server. Predictive price oracle combining AI models with on-chain data via Model Context Protocol for smart contract and DeFi integration.',
    downloads: 23400,
    stars: 670,
    version: '1.0.1',
    installCommand: '> install the pythia-oracle-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/pythia-oracle-mcp',
    usageExample: '> get predictive price\n> query AI price model\n> access oracle data',
    detailedDescription: 'Pythia Oracle MCP server combining machine learning price prediction with traditional oracle data. Access forward-looking price estimates, confidence intervals, and ML model predictions alongside on-chain oracle feeds.',
  },
  // ── QuickNode MCP ──
  {
    id: 'quicknode-mcp',
    name: 'quicknode-mcp',
    author: 'QuickNode',
    authorHandle: '@QuickNode',
    tag: 'Skill',
    category: 'tools',
    description: 'QuickNode MCP server. Enterprise blockchain infrastructure via Model Context Protocol — 60+ chains, 30+ add-ons, and NFT/DeFi APIs with premium RPC access.',
    downloads: 72400,
    stars: 2070,
    version: '2.1.0',
    installCommand: '> install the quicknode-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/quicknode-mcp',
    usageExample: '> connect to QuickNode\n> query 60+ chains\n> use NFT add-on',
    detailedDescription: 'QuickNode enterprise MCP server providing access to 60+ blockchain networks via premium RPC endpoints. Use NFT, token, and DeFi add-ons, access Streams for event data, and integrate QuickNode Functions for serverless compute.',
    featured: true,
    trending: true,
  },
  // ── Rug Munch MCP ──
  {
    id: 'rug-munch-mcp',
    name: 'rug-munch-mcp',
    author: 'Rug Munch',
    authorHandle: '@rugmunch',
    tag: 'Skill',
    category: 'tools',
    description: 'Rug Munch MCP server. Advanced rug-pull and scam detection via Model Context Protocol — on-chain honeypot detection, liquidity lock verification, and contract code analysis.',
    downloads: 38700,
    stars: 1100,
    version: '1.3.0',
    installCommand: '> install the rug-munch-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/mcp-servers/rug-munch-mcp',
    usageExample: '> detect honeypot\n> verify liquidity lock\n> analyze contract code',
    detailedDescription: 'Rug Munch MCP server for comprehensive scam detection. Identify honeypot contracts, verify liquidity lock duration and amount, analyze contract code for hidden backdoors, check deployer history, and generate rug risk scores.',
    trending: true,
  },
];